import {
  incompleteClaimFields,
  withIncompleteClaimValidation,
} from './incompleteClaim';
import { z } from 'zod';
import {
  claimEditBaseSchema,
  validateClaimHospitalFields,
  validateClaimProviderGroup,
  validateClaimTariffIcd9,
} from './claimEdit';
import { validateClaimLocationOfService } from './claimLocationOfService';
import { validateProvinceClaimFields } from './provinceClaimFields';

const completeClaimListSchema = claimEditBaseSchema
  .extend({
    claimQueryIDs: z.array(z.guid()).default([]),
    hasQueryResponse: z.boolean().default(false),
    relatedClaimCount: z.coerce.number().int().nonnegative().default(0),
    internalCommentSummary: z
      .object({ count: z.number().int().nonnegative(), latestText: z.string() })
      .strict()
      .nullable()
      .optional(),
  })
  .superRefine(validateClaimTariffIcd9)
  .superRefine(validateClaimProviderGroup)
  .superRefine(validateClaimLocationOfService)
  .superRefine(validateClaimHospitalFields)
  .superRefine(validateProvinceClaimFields);

export const claimListSchema = withIncompleteClaimValidation(
  completeClaimListSchema,
  z.object(completeClaimListSchema.shape).extend(incompleteClaimFields)
);

export type ClaimList = z.infer<typeof claimListSchema>;

export const isClaimList = (obj: unknown): obj is ClaimList => {
  return claimListSchema.safeParse(obj).success;
};
